import React from 'react'
import { sendSocialUserFacebook } from '../../actions/socialActions'
import { connect } from 'react-redux'
import ButtonSocial from '../../utils/components/ButtonSocial/ButtonSocial';
import { signFirebase } from '../../config/firebase';

const LoginFacebook = ({ sendSocialUser, sendSocialUserFacebook, model, domain, history }) => {

  const authenticate = (response) => {

    // console.log();
    sendSocialUserFacebook({
      accessToken: response.accessToken,
      userID: response.idToken
    }, history)

    // Api call to server so we can validate the token
  };

  const logout = () => {
    window.FB.api('/me/permissions', 'delete', function (response) {
      console.log(); // true for successful logout.
    })
    window.FB.logout(function (response) {
      console.log()
    });
    localStorage().clear()
  }

  return (
    <div>
      <ButtonSocial
        onClick={() => {
          signFirebase("facebook", authenticate)
        }}
        isFacebook={true} text="Facebook" />
    </div>
  )
}


export default connect(null, { sendSocialUserFacebook })(LoginFacebook)
